import { ApolloCache, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { GraphQLTypeMap, GraphQLTypes } from '../models/graphql';

const isEntityOfType = <T extends GraphQLTypes>(type: T, value: unknown): value is GraphQLTypeMap[T] => {
  return (
    typeof value === 'object' &&
    value !== null &&
    '__typename' in value &&
    (value as { __typename: string }).__typename === type
  );
};

export const getAllApolloCacheEntitiesOfType = <T extends GraphQLTypes>(
  cache: ApolloCache<object>,
  type: T
): GraphQLTypeMap[T][] => {
  const cacheData: NormalizedCacheObject = (cache as InMemoryCache).extract();

  return Object.keys(cacheData).reduce<GraphQLTypeMap[T][]>((acc, key) => {
    if (key.startsWith(`${type}:`)) {
      const entity = cacheData[key];
      if (isEntityOfType(type, entity)) {
        acc.push(entity);
      }
    }
    return acc;
  }, []);
};
